<div [ngClass]="sendedMail ? 'success' : 'error'" class="container">
  <mat-icon>{{ sendedMail ? "check_circle" : "error" }}</mat-icon>
  {{
    sendedMail ? "Email enviado!" : "Ops! Ocorreu um erro no envio do email."
  }}
</div>
